let sessionEndRefreshScheduled = false;

export const scheduleSessionEndPageRefresh = (delayMs = 250): void => {
    if (typeof window === "undefined" || sessionEndRefreshScheduled) return;
    // TV handles session completion through client-side navigation. A reload can
    // race its end request and restore stale bootstrap/authentication state.
    if (/^\/tv(\/|$)/.test(window.location.pathname)) return;

    sessionEndRefreshScheduled = true;
    window.setTimeout(() => {
        if (/^\/tv(\/|$)/.test(window.location.pathname)) {
            sessionEndRefreshScheduled = false;
            return;
        }
        const onSessionJoinRoute = /^\/(join-session|join|session)(\/|$)/.test(window.location.pathname);
        if (onSessionJoinRoute) {
            window.location.replace("/home");
            return;
        }

        window.location.reload();
    }, delayMs);
};
